<template>
    <div class="testPaper">
        <el-backtop target=".content .backtop"></el-backtop>
        <el-container>
            <wRHeader activeIndex="1"></wRHeader>
            <el-main>
                <div class="testPaper-main">
                    <!-- <SubviewLine :title="title" v-if="type != 6"></SubviewLine> -->
                    <SubviewLine title="" v-if="type != 6"></SubviewLine>
                    <div class="testPaper-main-content">
                        <div class="testPaper-item">
                            <div class="testPaper-item-title font-kai"><span>{{courseName}}-{{title}}</span></div>
                            <div class="testPaper-item-content" v-if="type == 6">
                                <div class="completion">
                                    <div class="completion-title">听写</div>
                                    <div class="completion-item">
                                        <div class="completion-item-left">
                                            <div class="left-question" v-for="(item,index) in reportDetail" :key="index">
                                                <div><span>{{index+1}}</span><img src="@/assets/image/ylc/11.png" alt="" @click="playTheVoice(item.remark)"></div>
                                                <div class="not-right" v-if="!item.isRight">
                                                    <el-input v-model="item.answer" placeholder="请输入内容" :disabled="true"></el-input>
                                                </div>
												<div v-if="item.isRight">
												    <el-input v-model="item.answer" placeholder="请输入内容" :disabled="true"></el-input>
												</div>
												<div class="show-answer" v-if="!item.isRight">
													<span style="color:dodgerblue;">答案：{{item.content}}</span>
												</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
							<div class="testPaper-item-content" v-if="type != 6" 
								v-loading.fullscreen.lock="loading"
								element-loading-text="获取报告中"
								element-loading-spinner="el-icon-loading"
								element-loading-background="rgba(0, 0, 0, 0.8)">
							    <div class="choiceQuestion">
							        <div class="choiceQuestion-title">英译汉</div>
									<div class="choiceQuestion-list">
										<div class="choiceQuestion-item" v-for="(item,index) in reportDetail" :key="index" v-if="item.subjectBody.type2 == 1">
										    <div>
												<span class="index-num">{{index+1}}、</span>
												<span>{{item.subjectBody.question}}</span>
												<img src="@/assets/image/ylc/11.png" alt="" @click="playTheVoice(item.subjectBody.url)">
											</div>
										    <div>
										        <el-radio-group v-model="item.answer" disabled>
										            <el-radio label="A">A.{{item.subjectBody.optionA}}</el-radio>
										            <el-radio label="B">B.{{item.subjectBody.optionB}}</el-radio>
										            <el-radio label="C">C.{{item.subjectBody.optionC}}</el-radio>
										            <el-radio label="D">D.{{item.subjectBody.optionD}}</el-radio>
										        </el-radio-group>
										    </div>
											<div class="standard-anwer">
												<!-- <span class="right-text" v-if="item.isRight">答案：{{item.subjectBody.answer}}</span> -->
												<span class="wrong-text" v-if="!item.isRight" >答案：{{item.subjectBody.answer}}</span>
											</div>
										</div>
									</div>
							        
							    </div>
							    <div class="choiceQuestion">
							        <div class="choiceQuestion-title">汉译英</div>
									<div class="choiceQuestion-list">
										<div class="choiceQuestion-item" v-for="(item,index) in reportDetail" :key="index" v-if="item.subjectBody.type2 == 2">
											<div>
												<span class="index-num">{{index+1}}、</span>
												<span>{{item.subjectBody.question}}</span>
											</div>
											<div>
												<el-radio-group v-model="item.answer" disabled>
													<el-radio label="A">A.{{item.subjectBody.optionA}}</el-radio>
													<el-radio label="B">B.{{item.subjectBody.optionB}}</el-radio>
													<el-radio label="C">C.{{item.subjectBody.optionC}}</el-radio>
													<el-radio label="D">D.{{item.subjectBody.optionD}}</el-radio>
												</el-radio-group>
											</div>
											<div class="standard-anwer">
												<!-- <span class="right-text" v-if="item.isRight">答案：{{item.subjectBody.answer}}</span> -->
												<span class="wrong-text" v-if="!item.isRight">答案：{{item.subjectBody.answer}}</span>
											</div>
										</div>
									</div>
							    </div>
							    <div class="completion">
							        <div class="completion-title">听写</div>
							        <div class="completion-item">
							            <div class="completion-item-left">
							                <div class="left-question" v-for="(item,index) in reportDetail" :key="index" v-if="item.subjectBody.type2 == 3">
							                    <div><span>{{index+1}}</span><img src="@/assets/image/ylc/11.png" alt="" @click="playTheVoice(item.subjectBody.url)"></div>
												<div class="not-right" v-if="!item.isRight">
												    <el-input v-model="item.answer" placeholder="请输入内容" :disabled="true"></el-input>
												</div>
												<div v-if="item.isRight">
												    <el-input v-model="item.answer" placeholder="请输入内容" :disabled="true"></el-input>
												</div>
												<div style="margin-top: 10px;">
													<!-- <span style="color:dodgerblue;">答案：{{item.subjectBody.answer}}</span> -->
													<span class="wrong-text" v-if="!item.isRight">答案：{{item.subjectBody.answer}}</span>
												</div>
							                </div>
							            </div>
							        </div>
							    </div>
							    <div class="completion">
							        <div class="completion-title">默写</div>
							        <div class="completion-item">
							            <div class="completion-item-left">
							                <div class="left-question" v-for="(item,index) in reportDetail" :key="index" v-if="item.subjectBody.type2 == 4">
							                    <div><span>{{index+1}}、{{item.subjectBody.question}}</span></div>
												<div class="not-right" v-if="!item.isRight">
												    <el-input v-model="item.answer" placeholder="请输入内容" :disabled="true"></el-input>
												</div>
												<div v-if="item.isRight">
												    <el-input v-model="item.answer" placeholder="请输入内容" :disabled="true"></el-input>
												</div>
												<div style="margin-top: 10px;">
													<!-- <span style="color:dodgerblue;">答案：{{item.subjectBody.answer}}</span> -->
													<span class="wrong-text" v-if="!item.isRight">答案：{{item.subjectBody.answer}}</span>
												</div>
							                </div>
							            </div>
							        </div>
							    </div>
							</div>
							<button class="close-button" @click="handleClose">关闭页面</button>
						</div>
                    </div>
                </div>
            </el-main>
        </el-container>
	</div>
</template>

<script>
	import { Message } from 'element-ui';
	import {selectSubjectReportList,getUserWrongList} from '@/api'
	export default{
		data(){
			return{
				achieveId:null,
				type:null,
				title:'',
				reportDetail:[],
				courseName:'',
				loading: true,
			}
		},
		methods:{
			// 关闭页面
			handleClose() {
				window.close()
			},
			
			// 获取报告的题目记录
			selectSubjectReportList(){
				console.log('获取报告————1',this.achieveId,this.type)
				selectSubjectReportList({
					achieveId:this.achieveId,
					type:this.type,
					pageNum:1,
					pageSize:999
				}).then(res =>{
					console.log('获取报告————res',res)
					if(!res.data.total) {
						setTimeout(()=>{
							location.reload(true)
							console.log('刷新')
							this.loading = false
						},800)
						
					}else {
						this.loading = false
					}
					this.courseName = res.data.rows[0].title 
					this.title = this.type != 9 ? (res.data.rows[0].content + '报告') : this.title
					let arr = []
					res.data.rows.forEach(item =>{
						if(item.answer) {
							if(item.subjectBody.type2 == 1){
								item.subjectBody.optionA = item.subjectBody.optionA.split(';')[0]
								item.subjectBody.optionB = item.subjectBody.optionB.split(';')[0]
								item.subjectBody.optionC = item.subjectBody.optionC.split(';')[0]
								item.subjectBody.optionD = item.subjectBody.optionD.split(';')[0]
							}else if(item.subjectBody.type2 == 2 ||item.subjectBody.type2 == 4){
								item.subjectBody.question = item.subjectBody.question.split(';')[0]
							}
							if(item.answer.trim() == item.subjectBody.answer.trim()){
								item.isRight = true
							}else {
								item.isRight = false
							}
							arr.push(item)
						}
						
					})
					if(!arr.length) return Message({message: '该报告已被删除',type: 'error',center: true,offset: 500})
					this.reportDetail = arr
				})
			},
			
			// 获取听写测试报告
			getUserWrongList(){
				console.log('获取听写测试报告————参数achieveId',this.achieveId)
				getUserWrongList({
					achieveId:this.achieveId,
					pageNum:1,
					pageSize: 999
				}).then(res =>{
					console.log('获取听写测试报告————res',res)
					this.loading = false
					let arr = []
					res.rows.forEach(item =>{
						if(item.content) {
							if(item.answer.trim() == item.content.trim()){
								item.isRight = true
							}else{
								item.isRight = false
							}
							arr.push(item)
						}
					})
					if(!arr.length) return Message({message: '该报告已被删除',type: 'error',center: true,offset: 500})
					this.reportDetail = arr
				})
			},
			
			// 播放音频
			playTheVoice(voice){
				console.log('播放音频')
			    let audio = new Audio()
			    audio.src = voice
			    audio.play()
			},
		
		},
		created() {
			this.achieveId = this.$route.query.achieveId
			this.type = this.$route.query.type
			this.courseName = this.$route.query.title
			// 听力测试
			if(this.type == 6){
				this.getUserWrongList()
			}else{
				this.selectSubjectReportList()
			}
			this.title = this.type == 6 ? '听写测试报告' : this.type == 9 ? '阶段测试报告' : this.title
		}
	}
</script>

<style lang="less">
	// 选项的标准答案
	.standard-anwer {
		margin: 10px 40px 20px;
	}
	.wrong-text {
		// color: red;
		color: dodgerblue;
		font-size: 22px;
	}
	// 序号
	.index-num {
		display: inline-block;
		width: 40px;
	}
	// 选项圈
	.el-radio__inner {
		position: relative;
		background-color: #ff5500!important;
		width: 15px;
		height: 15px;
		border: 4px solid #FFFFFF!important;
		box-shadow: 0 0 0 2px #ff5500;
	}
	.el-radio__inner::after {
		display: none;
	}
	.is-checked .el-radio__inner {
		background-color: #409EFF!important;
		width: 15px;//不能删
		height: 15px;
		box-shadow: 0 0 0 2px #409EFF!important;
	}
	
	.el-radio-group {
		margin-left: 40px;
		width: 100%;
		display: flex;
		// border: 1px solid #0B99FF;
		.el-radio {
			display: flex;
			flex: 0 0 23%;
			max-width: 23%;
			flex-wrap: nowrap;
			
			.el-radio__label {
				white-space: pre-line;
				display: flex;
				flex-wrap: wrap;
				// height: 50px;
				color: #000000!important;
			}
		}
		.el-radio:nth-child(4n) {
			max-width: 20%;
		}
	}
	
	// 默写框样式
	.el-input__inner{
		font-size:24px;
		height: 50px;
		color: #000000!important;
	}
	.not-right {
		.el-input__inner{
		 // font-family:"Microsoft";
		 font-size:24px;
		 height: 50px;
		 color: #e02020!important;
		}
	}
	.show-answer {
		margin-top: 10px;
		// border: 1px solid #187CFF;
		font-size: 24px;
	}
    .testPaper{
        width: 100%;
        /*height: 1080px;*/
        background-image: url("~@/assets/image/2.png");
        background-repeat: no-repeat;
        background-size: cover;
        .el-main {
            padding: 0;
        }
        .el-header{
            padding: 0;
        }
        .testPaper-main{
            display: flex;
            flex-direction: column;
            width: 1200px;
            margin: 0 auto;
            margin-top: 80px;
            .testPaper-main-content{
                padding-bottom: 95px;
                display: flex;
                .testPaper-item{
                    width: 1200px;
                    background: #FFFFFF;
                    box-shadow: 0 4px 17px 0 rgba(0,0,0,0.05);
                    /*min-height: 1464px;*/
                    display: flex;
                    flex-direction: column;
					justify-content: center;
					align-items: center;
                    .testPaper-item-title {
						// font-family:"楷体","楷体_GB2312";
                        width: 1100px;
                        height: 90px;
                        display: flex;
                        align-items: flex-end;
                        font-size: 36px;
                        color: #000000;
                        margin: 0 50px;
                        border-bottom: 1px solid #70CDCF;
                        span{
                            margin-bottom: 16px;
                        }
                    }
                    .testPaper-item-content{
                        margin: 30px 50px 25px;
                        width: 1100px;
                        border-radius: 4px;
                        background: #FAFAFA;
                        display: flex;
                        flex-direction: column;
                        .choiceQuestion{
							// border: 1px solid #000000;
                            width: 1100px;
                            display: flex;
                            flex-direction: column;
                            border-radius: 4px 4px 0 0;
                            // padding-bottom: 30px;
							.choiceQuestion-list {
								margin-top: 30px;
							}
                            .choiceQuestion-title{
                                width: 1100px;
                                height: 50px;
                                border-radius: 4px 4px 0 0;
                                background: #70CDCF;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 28px;
                                color: #000000;
                            }
                            .choiceQuestion-item{
								// border: 1px solid #000000;
                                width: 1040px;
                                margin: 0px 30px;
                                display: flex;
                                flex-direction: column;
                                & > div:first-child{
									// border: 1px solid #000000;
                                    width: 1040px;
                                    font-size: 24px;
                                    color: #000000;
                                    font-weight: bold;
                                    align-items: center;
                                    display: flex;
                                    img{
                                        margin-left: 10px;
										cursor: pointer;
                                    }
                                }
                                & > div:nth-child(2){
									// border: 1px solid #000000;
                                    margin-top: 15px;
                                }
                            }
                        }
                        .completion{
                            width: 1100px;
                            display: flex;
                            flex-direction: column;
                            border-radius: 4px 4px 0 0;
                            padding-bottom: 30px;
                            .completion-title{
                                width: 1100px;
                                height: 50px;
                                border-radius: 4px 4px 0 0;
                                background: #70CDCF;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 28px;
                                color: #000000;
                            }
                            .completion-item{
                                width: 1100px;
                                display: flex;
                                .completion-item-left{
                                    flex: 1100px;
                                    display: flex;
									flex-wrap: wrap;
                                    .left-question{
										// border: 1px solid #000000;
                                        width: 520px;
                                        margin: 15px 0 0 30px;
                                        display: flex;
                                        flex-direction: column;
                                        & > div:first-child{
                                            width: 520px;
                                            font-size: 24px;
                                            color: #000000;
                                            font-weight: bold;
                                            align-items: center;
                                            display: flex;
                                            img{
                                                margin-left: 10px;
                                                cursor: pointer;
                                            }
                                        }
                                        & > div:nth-child(2){
                                            width: 400px;
                                            margin-top: 15px;
                                            font-size: 17px;
                                        }
                                    }
                                }
                                .completion-item-right{
                                    flex: 550px;
                                    display: flex;
                                    flex-direction: column;
                                    .right-question{
                                        width: 520px;
                                        margin: 0 0 0 30px;
                                        display: flex;
                                        flex-direction: column;
										&:first-child{
											margin-top: 30px;
										}
                                        & > div:first-child{
                                            width: 520px;
                                            font-size: 24px;
                                            color: #000000;
                                            font-weight: bold;
                                            align-items: center;
                                            display: flex;
                                            img{
                                                margin-left: 10px;
                                                cursor: pointer;
                                            }
                                        }
                                        & > div:nth-child(2){
                                            width: 400px;
                                            margin-top: 15px;
                                            font-size: 17px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .sumbit-button{
                        width: 1200px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-bottom: 30px;
                        button{
                            width: 150px;
                            height: 45px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 17px;
                            color: #000000;
                            background: #70CDCF;
                            border-radius: 27.5px;
                            border: none!important;
                            outline:none;
                            cursor: pointer;
                            font-weight: bold;
                            &:hover{
                                opacity: 0.8;
                            }
                        }
                    }
                }
            }
        }
		button {
		    width: 200px;
		    height: 55px;
			margin-bottom: 30px;
		    display: flex;
		    align-items: center;
		    justify-content: center;
		    font-size: 17px;
		    color: #000000;
		    background: #70CDCF;
		    border-radius: 27.5px;
		    border: none !important;
		    outline: none;
		    cursor: pointer;
		    font-weight: bold;
		
		    &:hover {
		        opacity: 0.8;
		    }
		}
	}
</style>
